module.exports = __webpack_public_path__ + "media/images/flags/sl-c9bd0d0c625690921f86b526fc28abca.svg";